import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { stagingURL } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const bookingapi = createApi({
  reducerPath: "bookingAPI",
  baseQuery: axiosBaseQuery({ baseUrl: stagingURL }),
  endpoints: () => ({}),
});
